import { useCallback } from 'react';
import dayjs from 'dayjs';

import { useCopyToClipboard } from '../hooks/useCopyToClipboard';
import { ISubmitPaymentLinkOneTimePayment } from '../types/types';

const COPY_MESSAGES = {
  success: 'Código Pix copiado!',
  empty: 'Código Pix não disponível',
  error: 'Erro ao copiar código Pix',
};

export const useModalPaymentLinkPixBootstrap = (
  data?: ISubmitPaymentLinkOneTimePayment,
) => {
  const { copied, copy } = useCopyToClipboard(COPY_MESSAGES);

  const qrCode = data?.qrCode;

  const handleCopyCode = useCallback(() => copy(qrCode), [copy, qrCode]);

  const expiresAtLabel = data?.expiresAt
    ? dayjs(data.expiresAt).format('DD/MM/YYYY [às] HH:mm')
    : undefined;

  return {
    copied,
    handleCopyCode,
    canCopy: Boolean(qrCode),
    expiresAtLabel,
  };
};

export default useModalPaymentLinkPixBootstrap;
